export default {
  servicios: [],
  servicioSeleccionado: {},
  filtro: null,
  necesitaRecargar: true
};
